import { FlexiToggle } from "appworks/graphics/elements/flexi-toggle";
import { Text } from "appworks/graphics/pixi/text";
import { StopOnFeatureToggleControl } from "appworks/ui/controls/standard/toggle/stop-on-feature-toggle-control";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { slotModel } from "slotworks/model/slot-model";

export class AgsStopOnFeatureToggleControl extends StopOnFeatureToggleControl {

    constructor(protected button: FlexiToggle, protected label: Text) {
        super(button);

        const stopOnFeatureWin = slotModel.read().autoplay.stopOnFeatureWin;
        this.button.setValue(stopOnFeatureWin);

        if (!gameiomModel.displayStopOnFeatureButton) {
            button.setVisible(false);
            label.visible = false;
        }
    }
}
